import _ from "underscore";
import BaseTasksChangeDialog from "./BaseTasksChangeDialog";
import messageResource from "../../../messageResource";
import TaskStatusButton from "../../../controls/task/TaskStatusButton";
import {Feature, isEnabled} from '../../../features/index';
import TaskStatusMenu from '../../../controls/task/TaskStatusMenu'
import $ from 'jquery'

export default class ChangeTasksStatusDialog extends BaseTasksChangeDialog {

    constructor({$containerElement, cancelHandler = () => {}, submitHandler}) {
        super({$containerElement, cancelHandler, submitHandler});

        this.state = {
            ...this.state,
            defaultWorkflowStatusId: -1,
            selectedWorkflowStatusId: -1,
            disabled: false,
        }


        this.onStatePropertyChanged('defaultWorkflowStatusId', (id) => {
            this.setStateInternal({
                selectedWorkflowStatusId: id
            })
        })
        this.onStatePropertyChanged('selectedWorkflowStatusId', (id) => {
            this.taskStatusButton.setState({
                statusId: id
            });
        })
    }

    messageKeys() {
        return {
            labelText: "change_tasks_workflow_status.label",
            cancelButtonText: "common.cancel",
            submitButtonText: "common.apply"
        };
    }

    afterRender() {
        super.afterRender();

        const $selectorContainer = this.$el.find('.selectorContainer');
        $selectorContainer.empty();
        this.taskStatusButton = new TaskStatusButton({
            editable: true,
            showStatusTypePrefix: isEnabled(Feature.TWS),
            taskStatusMenu: new TaskStatusMenu($('body')).init(),
            onStatusChangedCb: (statusId) => {
                if (_.isUndefined(statusId) || statusId === null)
                    return
                this.setStateInternal({
                    selectedWorkflowStatusId: statusId
                })
                this.taskStatusButton.setState({
                    statusId
                })
            },
        }).init($selectorContainer)

        this.taskStatusButton.setState({
            canReopenProject: true,
        })
    }

    onSubmit() {
        if (!this.state.selectedWorkflowStatusId || this.state.saving)
            return;

        this.submitHandler(this.state.selectedWorkflowStatusId);
    }

    titleText() {
        if (this.state.numberOfTasks === 1)
            return messageResource.getMessage("change_tasks_workflow_status.change_status_of_selected_task");
        return messageResource.getMessage("change_tasks_workflow_status.change_status_of_selected_tasks", [this.state.numberOfTasks]);
    }
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/bulkOperations/components/ChangeTasksStatusDialog.js